<template>
  <div class="inpro">
    <div class="content">
      <div class="lmtit">推荐产品</div>
      <div class="lmxian"></div>
      <div class="nav">
        <ul>
          <router-link @click.native="changeProduction(1)" class="active" index="1" to=""><li >充电桩</li></router-link>
          <router-link @click.native="changeProduction(2)" index="2" to=""><li >储能</li></router-link>
          <div class="clean"></div>
        </ul>
      </div>
      <div class="nr">
        <el-row :gutter="20" >
            <el-col :span="8" :xs="24" :sm="12" :lg="8" v-for="(item,index) in images" :key="index">
              <ul>
              <li >
                <div class="pic">
                  <el-image :preview-src-list="imageSrcList" fit="contain" :src="item.url" />
                </div>
                <div class="tit">
                  {{ item.name }}
                </div>
              </li>
              </ul>
            </el-col>
        </el-row>
      </div>
      <router-link to="/production" class="more">进入产品中心</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Production",
  mounted() {
    this.changeProduction(1)
  },
  data(){
    return{
      activateIndex:-1,
      view:[],
      productionView:[
        {
          desc:"充电桩",
          type:1,
          images:[
            {name:"交流充电桩",url:require("../../assets/images/production/pile/交流.png")},
            {name:"直流充电桩120kw",url:require("../../assets/images/production/pile/直流桩60-120kw.jpg")},
            {name:"直流充电堆",url:require("../../assets/images/production/pile/充电堆360kw 480kw.jpg")}
          ]
        },
        {
          desc:"储能",
          type:2,
          images:[
            {name:"储能变流器",url:require("../../assets/images/production/barrier/储能变流器50-250K.jpg")},
            {name:"储能集装箱",url:require("../../assets/images/production/barrier/储能集装箱系统.jpg")},
            {name:"储充一体机",url:require("../../assets/images/production/barrier/光储充一体化.jpg")}
          ]
        }
      ],
      images:[],
      imageSrcList:[]
    }
  },
  methods:{
    changeProduction(index){
      //填充数据
      let prodView = this.productionView.filter(item=>item.type==index)
      this.images = prodView[0].images
      this.imageSrcList = this.images.map(item=>item.url)
      //变化样式
    }
  }
}
</script>

<style lang="less" scoped>

@import url(../../assets/css/style.css);
@import url(../../assets/css/reset.css);
@import url(../../assets/css/media.css);
.inpro{
  padding: 50px 0;
  background: #fbfbfb;
  border-top: 1px solid #dfdfdf;
  text-align: center;
  .lmtit{
    font-size: 30px;
    color: #333;
    margin-bottom: 10px;
    text-align: center;
  }
  .lmxian{
    height: 1px;
    width: 60px;
    background: #287ab6;
    margin: 0 auto;
  }
}
.inpro .nav{
  padding: 20px 0;
  text-align: center;
}
.inpro .nav ul li{
  display: inline-block;
  line-height: 30px;
  font-size: 16px;
  padding: 0 15px;
  border: 1px solid #999;
  color: #333;
  border-radius: 5px;
  margin: 5px;
  &:hover{
    border: 1px solid #287ab6;
    background: #287ab6;
    color: #fff;
  }
}



.inpro .nr{
  margin-bottom: 30px;
  ul li{
    overflow: hidden;
    position: relative;
    margin: 10px;
    &:hover .pic {
      transition: all .8s;
      transform: scale(1.2,1.2);
    }
    &:hover .tit{
      opacity: 0;
    }
    .pic{
      overflow: hidden;
      height: 370px;
      width: 100%;
      background-color: #fdfdee;
      .el-image{
        width: auto;
        height: 370px;
      }
    }
    .tit{
      transition: all .5s;
      height: 45px;
      line-height: 45px;
      z-index: 999;
      background: rgba(40,122,182,.5);
      text-align: center;
      color: #fff;
      font-size: 16px;
      position: absolute;
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      left: 0;
      top: 50%;
      margin-top: -22px;
    }
  }
}
.inpro .more{ display: block; width: 120px; height: 25px; line-height: 25px; font-size: 12px; border: 1px solid #287ab6; text-align: center; color: #287ab6; margin: 0 auto; }
.inpro .more:hover{ background: #287ab6; color: #fff; }
</style>
